// src/private/src/pages/app/clients/ClientListPage.jsx
import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import api from '@src/api/clients';

export default function ClientListPage() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    api.request({ url: 'dashboard/clients/', method: 'GET' })
      .then((res) => {
        setClients(res.data);
      })
      .catch((err) => console.error('Failed to load clients:', err))
      .finally(() => setLoading(false));
  }, []);

  const filteredClients = clients.filter(c =>
    c.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">Clients</Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/clients/new/')}
        >
          + Add Client
        </Button>
      </Box>

      <Card>
        <CardContent>
          <TextField
            placeholder="Search by name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            sx={{ mb: 2 }}
          />

          {loading ? (
            <Box display="flex" justifyContent="center" mt={5}><CircularProgress /></Box>
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Active</TableCell>
                    <TableCell>Goal #</TableCell>
                    <TableCell>Last Updated</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {filteredClients.map((client) => (
                <TableRow key={client.id} hover>
                    <TableCell>
                        <Box display="flex" alignItems="center" gap={2}>
                        {client.client_logo_url ? (
                            <img
                                src={client.client_logo_url}
                                alt="Logo"
                                style={{
                                height: 36,
                                width: 36,
                                objectFit: 'contain',
                                borderRadius: 6,
                                backgroundColor: '#fff',
                                padding: 4,
                                border: '1px solid #e0e0e0'
                                }}
                                onError={(e) => { e.target.style.display = 'none'; }}
                            />
                            ) : (
                            <Box
                                height={36}
                                width={36}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                borderRadius={6}
                                border="1px solid #e0e0e0"
                                bgcolor="#f5f5f5"
                                fontSize={12}
                                color="#999"
                            >
                                N/A
                            </Box>
                            )}
                            <Typography variant="body2" fontWeight={500}>
                            {client.name}
                            </Typography>
                        </Box>
                        </TableCell>
                      <TableCell>{client.active ? '✅' : '❌'}</TableCell>
                      <TableCell>{client.goal_number ?? '-'}</TableCell>
                      <TableCell>{client.last_backend_update ? new Date(client.last_backend_update).toLocaleString() : '-'}</TableCell>
                      <TableCell align="right">
                        <IconButton onClick={() => navigate(`/clients/${client.id}/`)}>
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
